import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { Device, until } from '@helpers/media';
import { paragraphSmall } from '@helpers/typography';
import styled, { css } from 'styled-components';
const Container = styled.nav `
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  width: 100%;
  gap: 10px;
`;
const List = styled.div `
  display: flex;
  align-items: center;
  gap: inherit;
`;
const sharedStyles = css `
  ${paragraphSmall};

  --colourBg: 'transparent';
  --colourText: ${brand.primary.blue};
  --colourTextActive: ${brand.global.white};
  --colourBgActive: ${brand.primary.blue};

  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 0;
  font-weight: 700;
  height: 39px;
  padding: 0;
  margin: 0;
  color: var(--colourText);
  background: var(--colourBg);
`;
const Item = styled.button `
  ${transition('background-size, border-color', 0.2)};
  ${sharedStyles};

  background-image: linear-gradient(to right, var(--colourBgActive), var(--colourBgActive));
  background-repeat: no-repeat;
  background-size: 0% 100%;
  width: 39px;
  border-radius: 8px;
  border: 1px solid var(--colourBgActive);

  > svg {
    width: 18px;
  }

  &[data-prev] > svg {
    transform: rotate(90deg);
  }

  &[data-next] > svg {
    transform: rotate(-90deg);
  }

  &.focus-ring {
    outline-style: solid;
    outline-offset: 2px;
    outline-width: 1px;
    outline-color: var(--colourBgActive);
  }

  &[aria-current='page'],
  &:not(:disabled):focus,
  &:not(:disabled):hover {
    background-size: 100% 100%;
    color: var(--colourTextActive);
  }

  &:not([aria-current='page']):disabled {
    opacity: 0.3;
  }

  @media ${until(Device.MobileLarge)} {
    &[data-hidden-mobile='true'] {
      display: none;
    }
  }
`;
const Separator = styled.span `
  ${sharedStyles};
`;
const PaginationStyles = {
    Container,
    Item,
    List,
    Separator,
};
export default PaginationStyles;
